import React from "react";

import { FormCategory } from "@simplyk/common";

import { DashboardIconProps } from "@/dashboard-design-system/Icon/DashboardIcon";

export type ShareThisProps = React.PropsWithChildren<{
  palette?: "zeffy" | "default";
  description?: string;
  buttons?: ShareThisButton[];
  size?: DashboardIconProps["size"];
  title?: string;
  subTitle?: string;
  url?: string | null;
  overrides?: { facebookUrl?: string; messengerUrl?: string };
  classes?: {
    root?: string;
    subtitle?: string;
  };
  centered?: boolean;
  from?: "ReferralPage" | "ThankYouPage";
  spaceBetweenButton?: number;
  noMargin?: boolean;
  formCategory?: FormCategory | null;
  buttonSize?: number;
  iconColor?: string;
  circleColor?: string;
}>;

export enum ShareThisButton {
  Copy = "copy",
  Email = "email",
  Facebook = "facebook",
  Linkedin = "linkedin",
  Messenger = "messenger",
  X = "x",
  Whatsapp = "whatsapp",
  Instagram = "instagram",
}
